import constants from "../constants";

export default {
  saveToken(tokenData) {
    return Promise.resolve(
      this.store(constants.STORAGE_KEY.TOKEN_DATA, JSON.stringify(tokenData))
    );
  },

  // Lanh dao edit luong van ban
  getGlobalConfigEditNode(){
    return localStorage.getItem("globalConfigEditNode") === 'true';
  },

  storeGlobalConfigEditNode(value){
    localStorage.setItem("globalConfigEditNode", value);
  },

  removeGlobalConfigEditNode(){
    localStorage.removeItem("globalConfigEditNode");
  },

  // Cho phep soan thao van ban file word
  getGlobalConfigEditNodeSoanThaoVb(){
    return localStorage.getItem("globalConfigEditNodeSoanThaoVb") === 'true';
  },

  storeGlobalConfigEditNodeSoanThaoVb(value){
    localStorage.setItem("globalConfigEditNodeSoanThaoVb", value);
  },

  storeGlobalConfigSigning(value){
    localStorage.setItem("config-signing", value);
  },


  removeGlobalConfigEditNodeSoanThaoVb(){
    localStorage.removeItem("globalConfigEditNodeSoanThaoVb");
  },

  getTokenData() {
    let tokenDataStr = this.get(constants.STORAGE_KEY.TOKEN_DATA);
    return tokenDataStr ? JSON.parse(tokenDataStr) : null;
  },

  saveOtpToken(otpToken) {
    console.log("otpToken: " + otpToken);
    return Promise.resolve(
      this.store(constants.STORAGE_KEY.OTP_TOKEN, otpToken)
    );
  },

  removeToken() {
    this.remove(constants.STORAGE_KEY.TOKEN_DATA);
    this.remove(constants.STORAGE_KEY.OTP_TOKEN);
    return Promise.resolve(null);
  },

  checkIsAuthenticated() {
    let tokenDataStr = this.get(constants.STORAGE_KEY.TOKEN_DATA);
    let otpToken = this.getOtpToken();
    if (otpToken) {
      //console.log('otp token');
      return Promise.resolve(tokenDataStr && otpToken ? JSON.parse(tokenDataStr) : null);
    } else {
      console.log('Not otp token');
      console.log('SMART_OFFICE_USING_SMS', constants.SMART_OFFICE_USING_SMS);
      if (constants.SMART_OFFICE_USING_SMS){
        return Promise.resolve(null);
      }else{
        return Promise.resolve(tokenDataStr ? JSON.parse(tokenDataStr) : null);
      }
    }
  },

  getIdToken() {
    let tokenData = this.getTokenData();
    return tokenData ? tokenData["id_token"] : null;
  },
  getRefreshToken() {
    let tokenData = this.getTokenData();
    return tokenData ? tokenData["refresh_token"] : null;
  },
  saveNewIDToken(id_token) {
    let tokenData = this.getTokenData();
    if (!tokenData) return null;
    tokenData["id_token"] = id_token;
    return Promise.resolve(
      this.store(constants.STORAGE_KEY.TOKEN_DATA, JSON.stringify(tokenData))
    );
  },

  getOtpToken() {
    return this.get(constants.STORAGE_KEY.OTP_TOKEN);
  },

  getSessionId() {
    return this.get(constants.STORAGE_KEY.SESSION_ID);
  },

  saveSessionId(sessionId) {
    return Promise.resolve(
      this.store(constants.STORAGE_KEY.SESSION_ID, sessionId)
    );
  },

  saveUSID(userId) {
      return this.store(constants.STORAGE_KEY.USID, userId)
  },

  getUSID() {
    return this.get(constants.STORAGE_KEY.USID);
  },

  getCheckLogoutError() {
    return this.get(constants.STORAGE_KEY.CHECK_LOGOUT_ERROR);
  },

  saveLogoutError() {
    return Promise.resolve(
      this.store(constants.STORAGE_KEY.CHECK_LOGOUT_ERROR, 'logout')
    );
  },

  removeLogoutError() {
    return localStorage.removeItem(constants.STORAGE_KEY.CHECK_LOGOUT_ERROR);
  },

  storeLastURL(lastURL) {
    localStorage.setItem("lastURL", lastURL);
  },

  getLastURL() {
    return localStorage.getItem("lastURL");
  },

  removeLastURL() {
    return localStorage.removeItem("lastURL");
  },

  store(key, value) {
    value == null || value === undefined ? localStorage.removeItem(key) : localStorage.setItem(key, value);
  },

  get(key) {
    return localStorage.getItem(key);
  },

  remove(key) {
    return localStorage.removeItem(key);
  },

  storeStateBeforeLogin(to) {
    let stateURLBeforeLogin = {
      URL: to.path,
      ID: ("id" + new Date().getTime()).toString(),
      QUERY: to.query,
      PARAMS: to.params,
      ROUTER_NAME: to.name
    };
    this.store(
      constants.STATE_URL_BEFORE_LOGIN,
      JSON.stringify(stateURLBeforeLogin)
    );
    // console.log(JSON.stringify(stateURLBeforeLogin));
    return Promise.resolve(null);
  }
};



// WEBPACK FOOTER //
// ./src/services/authenService.js